import gql from 'graphql-tag';

export default gql`
  mutation adminEditSiteProfile($input: AdminEditSiteProfileInput!) {
    adminEditSiteProfile(input: $input) {
      id
    }
  }
`;
